export const trackFbqEvent = (eventName: string, eventProperties: any) => {
  if (process.env.NODE_ENV === "production") {
    // @ts-ignore
    fbq("track", eventName, eventProperties);
  } else {
    console.log("Skipping fbq event", eventName, eventProperties);
  }
};
